
import { mixins, Options, Prop } from 'vue-property-decorator'

import ContentCardMixin from '../../mixins/ContentCardMixin'
import GalleryFull from '../icons/GalleryFull.vue'
import Play from '../icons/Play.vue'
import NavLink from '../NavLink.vue'
import Tag from '../Tag.vue'
import ContentImage from './ContentImage.vue'

@Options({
  name: 'ContentCardImg',
  components: {
    ContentImage,
    GalleryFull,
    NavLink,
    Play,
    Tag
  }
})
export default class ContentCardImg extends mixins(ContentCardMixin) {
  @Prop({
    type: Boolean,
    default: false
  })
  readonly isLcp!: boolean
}
